import { render, staticRenderFns } from "./ShowAbilityTable.vue?vue&type=template&id=4ed45547&scoped=true"
import script from "./ShowAbilityTable.vue?vue&type=script&lang=js"
export * from "./ShowAbilityTable.vue?vue&type=script&lang=js"
import style0 from "./ShowAbilityTable.vue?vue&type=style&index=0&id=4ed45547&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ed45547",
  null
  
)

export default component.exports